import React from "react";
import { CloseCircleTwoTone } from "@ant-design/icons";
import { Modal } from "antd";

const ErrorPopup = ({ open, onClose, message }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      bodyStyle={{ textAlign: "center", padding: 30 }}
    >
      <CloseCircleTwoTone
        twoToneColor="#ff4d4f"
        style={{ fontSize: 80, marginBottom: 20 }}
      />
      <h2 style={{ marginBottom: 10 }}>Failed</h2>
      <p style={{ fontSize: 16 }}>{message}</p>

      <button
        onClick={onClose}
        style={{
          marginTop: 20,
          padding: "10px 20px",
          background: "#ff4d4f",
          border: "none",
          color: "#fff",
          borderRadius: 6,
          cursor: "pointer",
        }}
      >
        Close
      </button>
    </Modal>
  );
};

export default ErrorPopup;
